import React, { createContext, useContext, useEffect, useState } from 'react';
import { MotionConfig } from 'framer-motion';

const MotionCapabilitiesContext = createContext({
  prefersReducedMotion: false,
  isTouch: false,
  canHover: true
});

export const useMotionCapabilities = () => useContext(MotionCapabilitiesContext);

export const useReducedMotionPreference = () => {
  const { prefersReducedMotion } = useContext(MotionCapabilitiesContext);
  return { prefersReducedMotion };
};

export const MotionProvider = ({ children }) => {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);
  const [isTouch, setIsTouch] = useState(false);
  const [canHover, setCanHover] = useState(true);

  useEffect(() => {
    // Check prefers-reduced-motion media query
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    setPrefersReducedMotion(motionQuery.matches);

    const handleMotionChange = (e) => setPrefersReducedMotion(e.matches);
    motionQuery.addEventListener?.('change', handleMotionChange);

    // Check pointer capabilities (touch vs fine mouse pointer)
    const pointerQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    setCanHover(pointerQuery.matches);
    setIsTouch(!pointerQuery.matches || 'ontouchstart' in window);

    const handlePointerChange = (e) => {
      setCanHover(e.matches);
      setIsTouch(!e.matches);
    };
    pointerQuery.addEventListener?.('change', handlePointerChange);

    return () => {
      motionQuery.removeEventListener?.('change', handleMotionChange);
      pointerQuery.removeEventListener?.('change', handlePointerChange);
    };
  }, []);

  return (
    <MotionCapabilitiesContext.Provider value={{ prefersReducedMotion, isTouch, canHover }}>
      <MotionConfig reducedMotion="user">
        {children}
      </MotionConfig>
    </MotionCapabilitiesContext.Provider>
  );
};

export default MotionProvider;
